export enum InvestmentSwitchTypeOptionsTypeEnum {
    current = 1,
    future = 2
}